<template>
  <div 
    v-if="prodPolicies.length" 
    class="insu-prod-policy"
  >
    <h3 class="mb-s section-title">商品條款</h3>
    <div class="prod-policy-list">
      <p
        v-for="(policy, index) in prodPolicies"
        :key="index"
        class="fz-tiny"
        :style="{marginBottom: '5px'}"
      >
        <a
          :href="policy.url"
          target="_blank"
          v-text="policy.title"
        />
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      prodPolicies: {
        type: Array,
        default: null
      }
    }
  };
</script>